import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { apiService } from '../../api-base'
import { ReportType, ReportsResponse, types } from './types'
import { FormDataReport } from '~/entities/reports/model/types'

export class ReportsServices {
  static getReports(config: AxiosRequestConfig) {
    return apiService.get<ReportsResponse>('/reports', config)
  }

  static createReport(data: FormDataReport) {
    return apiService.post<ReportType>('/reports', data)
  }

  static getReportsTypes(): Promise<AxiosResponse<types[]>> {
    return apiService.get<AxiosResponse<types[]>>('/reports/types')
  }
}
